import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>ABOUT COMPANY</h3>
            <p>We support you professionally and with foresight in the challenges posed by technological change and progress. In doing so, we always focus on one thing - people.</p>
            <div className="contact-info">
              <p><i className="fas fa-map-marker-alt"></i> 97 Blenheim Road, Bolton, England, BL2 6EL</p>
              <p><i className="fas fa-phone"></i> +447586094540</p>
              <p><i className="fas fa-envelope"></i> info@codes-ai.com</p>
            </div>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="#about">About Us</a></li>
              <li><a href="#team">Team</a></li>
              <li><a href="#faq">Faq</a></li>
              <li><a href="#projects">Projects</a></li>
              <li><a href="#contact">Contact us</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>IT SERVICES</h3>
            <ul>
              <li><a href="#terms">Terms & Condition</a></li>
              <li><a href="#careers">Careers</a></li>
              <li><a href="#privacy">Privacy Policy</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Other Links</h3>
            <ul>
              <li><a href="#what-we-offer">What we Offer</a></li>
              <li><a href="#our-story">Our Story</a></li>
              <li><a href="#latest-posts">Latest Posts</a></li>
              <li><a href="#help-center">Help Center</a></li>
              <li><a href="#our-partners">Our Partners</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>&copy; 2025 codes-ai. All Rights Reserved.</p>
          </div>
          <div className="footer-social">
            <a href="#facebook"><i className="fab fa-facebook"></i></a>
            <a href="#twitter"><i className="fab fa-twitter"></i></a>
            <a href="#linkedin"><i className="fab fa-linkedin"></i></a>
            <a href="#github"><i className="fab fa-github"></i></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 